export var AvailabilityEnum;
(function (AvailabilityEnum) {
    AvailabilityEnum["Yes"] = "Yes";
    AvailabilityEnum["No"] = "No";
    AvailabilityEnum["Unknown"] = "Unknown";
})(AvailabilityEnum || (AvailabilityEnum = {}));
export var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum["All"] = "All";
    CategoryEnum["Ammunition"] = "Ammunition";
    CategoryEnum["ShortWeapon"] = "ShortWeapon";
    CategoryEnum["LongWeapon"] = "LongWeapon";
    CategoryEnum["Shotgun"] = "Shotgun";
    CategoryEnum["SpecialOffers"] = "SpecialOffers";
    CategoryEnum["BlackPowder"] = "BlackPowder";
})(CategoryEnum || (CategoryEnum = {}));
